import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as schemas from '../../../assets/schemas/schemas';
import {
  ActionButton,
  AltButton,
  LogoButton,
} from '../../common/Buttons/Buttons';
import logo from '../../../images/logo.svg';
import { membershipService } from '../../../services/membershipService.js';
import { membershipCatalogService } from '../../../services/membershipCatalogService.js';
import { paymentsService } from '../../../services/paymentsService.js';
import { productService } from '../../../services/productService.js';
import { giftCardService } from '../../../services/giftCardService.js';
import { economicActivitiesService } from '../../../services/economicActivitiesService';
import { discountService } from '../../../services/discountService';
import { notify } from '../../../assets/helpers/toast';
import { Input } from '../../common/Forms/Input/Input.jsx';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner';
import {
  filterParams,
  NaNtoNumber,
  validateIfOther,
  isPaymentMethodZelleOrPaypal,
  filterById,
  capitalize,
  checkNumValue,
  filterRCVOptions,
} from '../../../assets/helpers/funciones.js';
import { bancamigaService } from '../../../services/bancamigaService';
import { rateService } from '../../../services/rateService';
import {
  LANDING,
  codeTypeOptions,
  codeTypeEnum,
  paymentMethods,
  paymentType as paymentTypeOption,
  vehicleUsageOptions,
  rcvEnum,
  validateCodeEnum,
  membershipCodes,
  maskMembershipPlanName,
  getMembershipCode,
  getDefaultPlanKm,
  getKmServiceOptions,
  getUnlimitedTowLabel,
  planAllowsUnlimitedTow,
} from '../../../assets/helpers/options.js';
import { useHistory, useParams } from 'react-router-dom';
import { RenewPayment } from './RenewPayment.jsx';
import moment from 'moment';
import './Login.scss';

export const Renovation = () => {
  const [isLoading, setIsloading] = useState(false);
  const [planOptions, setPlanOptions] = useState([]);
  const [paymemtMethodOptions, setPaymemtMethodOptions] = useState([]);
  const [rcvOptions, setRCVOptions] = useState([]);
  const [dollarRate, setDollarRate] = useState(1);
  const [priceInfo, setPriceInfo] = useState('');
  const [discountId, setDiscountId] = useState('');
  const [selectedMethod, setSelectedMethod] = useState('');
  const [economicActivitiesOptions, setEconomicActivitiesOptions] = useState(
    []
  );

  const [membership, setMembership] = useState('');
  const [selectedMembership, setSelectedMembership] = useState('');
  const [fileUploaded, setFileUploaded] = useState([]);

  const [stripeModal, setStripeModal] = useState({
    isOpen: false,
    methods: [],
  });
  const [payment, setPayment] = useState({
    amount: 1,
    amountBsS: 1,
    methods: [],
    reference: '',
  });

  const [dontShowDiscount, setDontShowDiscount] = useState(false);

  const { membershipId } = useParams();
  const history = useHistory();

  const {
    register,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemas.autorenovationSearchSchema()),
    defaultValues: {
      plate: 'MFB76T',
      identification: '24223944',
    },
  });

  const {
    register: register2,
    setValue: setValue2,
    watch: watch2,
    control: control2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    setError: setError2,
  } = useForm({
    resolver: yupResolver(schemas.autorenovationPaymentSearchSchema()),
  });

  const autoDiscountRequestRef = useRef('');
  const promoAutoAppliedRef = useRef('');
  const rcvRequestSeqRef = useRef(0);
  const [rcvLoadedPlanId, setRcvLoadedPlanId] = useState('');
  const selectedCode = watch('code');
  const selectedRcv = watch('rcv');
  const selectedCodeType = watch('codeType');
  const selectedCoupon = watch('codigo');

  const getStoredMembership = () => {
    const membershipRaw = localStorage.getItem('membership');
    if (!membershipRaw) {
      return null;
    }

    try {
      return JSON.parse(membershipRaw);
    } catch {
      return null;
    }
  };

  const getContractedCraneKm = () => {
    const stored = getStoredMembership();
    const raw = stored?.vehicle?.membership?.km;
    const value = Number(raw);
    return Number.isFinite(value) && value > 0 ? value : '';
  };

  const getPlanOption = planId => planOptions?.find(plan => plan?._id === planId);

  const isGoldPlanName = name =>
    [membershipCodes?.GOLD, membershipCodes?.GOLDM].includes(name);

  const resolveRenewalKm = planId => {
    const selected = getPlanOption(planId);
    if (!selected || !isGoldPlanName(selected?.name)) {
      return '';
    }

    const currentKm = watch('km');
    if (currentKm) {
      return currentKm;
    }

    return getDefaultPlanKm(selected?.name, getContractedCraneKm());
  };

  const syncPlanExtras = planId => {
    const selected = getPlanOption(planId);
    if (!selected) {
      return;
    }

    setValue('km', resolveRenewalKm(planId));
    if (!planAllowsUnlimitedTow(selected?.name)) {
      setValue('hasExtendedTow', false);
    }
  };

  const isEligibleForAutoDiscount = membershipData => {
    const normalizedAccidentRate = String(
      membershipData?.vehicle?.membership?.accidentRate || ''
    )
      .trim()
      .toUpperCase();

    return ['ORO', 'PLATA'].includes(normalizedAccidentRate);
  };

  const getAvailableMemberships = membership => {
    let params = {
      year: membership?.vehicle?.year,
      class: membership?.vehicle?.class?._id || membership?.vehicle?.classId,
      landing: LANDING?.SELF_RENEWAL,
    };

    membershipCatalogService
      .getAvailableMemberships(filterParams(params))
      .then(response => {
        if (response.status === 200) {
          let data = [];

          for (let i = 0; i < response?.data.length; i++) {
            data?.push({
              name: maskMembershipPlanName(response?.data[i]?.code),
              _id: response?.data[i]?._id,
            });
          }
          // filter ridery and BERA plans (BERA temporarily hidden until enabled)
          data = data?.filter(
            p =>
              ![membershipCodes?.RIDERY, membershipCodes?.BERA].includes(
                p?.name
              )
          );
          setPlanOptions(data);
          let [currentMembership] = data?.filter(
            m =>
              m?.name ===
              maskMembershipPlanName(membership?.vehicle?.membership?.code)
          );

          if (currentMembership) {
            setValue('code', currentMembership?._id);
            const contractedKm = Number(membership?.vehicle?.membership?.km);
            setValue(
              'km',
              isGoldPlanName(currentMembership?.name)
                ? getDefaultPlanKm(
                    currentMembership?.name,
                    Number.isFinite(contractedKm) ? contractedKm : ''
                  )
                : ''
            );
            if (
              planAllowsUnlimitedTow(currentMembership?.name) &&
              membership?.vehicle?.membership?.hasExtendedTow
            ) {
              setValue('hasExtendedTow', true);
            }
            getRCVs(currentMembership?._id);
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const handleDiscountCode = () => {
    if (watch('codigo')?.length >= 6 && watch('code')) {
      validateCode({
        code: watch('codigo'),
        codeType: watch('codeType'),
        planId: watch('code'),
      });
    }

    // if (watch('codigo').trim().length >= 6) {
    //   notify('Ingrese un código válido', 'info');
    // setValue('codigo', watch('codigo').slice(0, 6));
    // }
  };

  const getEconomicActivities = () => {
    economicActivitiesService
      .getEconomicActivities()
      .then(response => {
        if (response.status === 200) {
          setEconomicActivitiesOptions(response?.data?.activities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const successfulStripe = paymentNumber => {
    setValue2(`reference${paymentNumber}`, 'PAGO REALIZADO');
    setValue2(
      `method${paymentNumber}`,
      paymemtMethodOptions.filter(p => p.name === paymentMethods?.STRIPE)[0]
        ?._id
    );

    setStripeModal(prevState => {
      return {
        ...prevState,
        isOpen: !stripeModal?.isOpen,
        methods: [],
        amount: 0,
        paymentNumber: '',
        selectedMembership: '',
      };
    });
  };

  const getDollarRate = () => {
    rateService
      .getDollarRate()
      .then(response => {
        if (response.status === 200) {
          setDollarRate(response?.data?.rate);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => { });
  };

  const removeImage = paymentNumber => {
    setValue2(`reference${paymentNumber}`, '');
    let images = [...fileUploaded];

    images[paymentNumber] = '';
    setFileUploaded(images);

    setPayment(prevState => {
      return {
        ...prevState,
        isOpen: false,
        methods: [],
        paymentNumber: paymentNumber,
        reference: '',
      };
    });
  };

  const handleStipeModal = (amount, paymentNumber) => {
    let selectedPaymentMethods = paymemtMethodOptions.filter(
      p => p.name === paymentMethods?.STRIPE
    );

    setStripeModal(prevState => {
      return {
        ...prevState,
        isOpen: !stripeModal?.isOpen,
        methods: selectedPaymentMethods,
        paymentNumber:
          paymentNumber || paymentNumber === 0 ? paymentNumber : '',
        amount: amount ? amount : 0,
        amountBsS: amount ? amount * dollarRate : 0,
        selectedMembership: selectedMembership || '',
      };
    });
  };

  const getPaymentMethods = () => {
    productService
      .getPaymentMethods('sales')
      .then(response => {
        if (response.status === 200) {
          const PM = [
            paymentMethods.PAGO_MÓVIL,
            paymentMethods.PAGO_MÓVIL_BNC,
            paymentMethods.PAGO_MÓVIL_MERCANTIL,
            paymentMethods.PAGO_MÓVIL_GENERICO,
            paymentMethods.PAGO_MOVIL_BANPLUS,
          ];
          const TRANSFER = [
            paymentMethods.TRANSFERENCIA_MERCANTIL,
            paymentMethods.TRANSFERENCIA_BANESCO,
            paymentMethods.TRANSFERENCIA_BNC,
            paymentMethods.TRANSFERENCIA_BANPLUS,
            paymentMethods.TRANSFERENCIA_GENERICO,
            paymentMethods.BANK_TRANSFER,
          ];
          const CASH = [
            paymentMethods.CASH_BS,
            paymentMethods.CASH,
            paymentMethods.CASH_EUR,
            paymentMethods.CASH_USD,
          ];

          let filteredMethods = response?.data?.filter(
            d =>
              ![
                paymentMethods.CASHEA,
                ...PM,
                ...TRANSFER,
                ...CASH,
                paymentMethods.RETENCION_IVA,
                paymentMethods.DEPOSITO_BANCAMIGA,
                paymentMethods.RETENCION_ISLR,
                paymentMethods.VENPAY,
                paymentMethods.PUNTO_DE_VENTA,
                paymentMethods.VENFLOW,
                paymentMethods.PAGO_MOVIL_R4,
                paymentMethods.PAGO_EN_COMERCIO,
                paymentMethods.DÉBITO_INMEDIATO_LINK,
                paymentMethods.PAGO_DIRECTO,
              ].includes(d?.name)
          );

          filteredMethods = filteredMethods?.filter(
            d =>
              ![
                paymentMethods.PAGO_MÓVIL_R4,
                paymentMethods.PAGO_DIRECTO,
                paymentMethods.PAGO_EN_COMERCIO,
              ].includes(d?.name)
          );

          setPaymemtMethodOptions(filteredMethods);
        } else {
          notify(`${response.message}`, 'error');
        }
      })
      .catch(() => { });
  };

  const validateBancamigaPM = async (index, PMpaymentMethod) => {
    let data = {
      date: watch2(`date${index}`)
        ? moment(watch2(`date${index}`)).format('YYYY-MM-DD')
        : '',
      bank: watch2(`bank${index}`), // Bancamiga by default
      phone: '58' + watch2(`phone${index}`),
      reference: watch2(`reference${index}`),
      method: PMpaymentMethod?._id,
    };
    return bancamigaService
      .checkPayment(data)
      .then(response => {
        if (response.status === 200) {
          if (response?.data?.wasFound) {
            return true;
          } else {
            notify(`No se pudo validar el pago movil`, 'error');
            return false;
          }
        } else {
          notify(`${response.message}`, 'error');
          return false;
        }
      })
      .catch(() => { });
  };

  const validatePagoMovil = async (params, index, PMpaymentMethod) => {
    let isValid = true;
    if (watch2(`phone${index}`)?.length !== 10) {
      setError2(`phone${index}`, {
        type: 'custom',
        message: 'Ingrese un numero de telefono valido: Ejemplo: 4143579865',
      });
      return false;
    } else {
      setError2(`phone${index}`, { type: 'custom', message: '' });
    }

    for (let i = 0; i < params?.length; i++) {
      if (!watch2(`${params[i]}${index}`)) {
        setError2(`${params[i]}${index}`, {
          type: 'custom',
          message: 'Obligatorio',
        });
        isValid = false;
      }
    }
    // Validate PM against bancamiga API
    let validPM = await validateBancamigaPM(index, PMpaymentMethod);
    if (!validPM) {
      return false;
    }
    return isValid;
  };

  const acceptPayment = async () => {
    let PMpaymentMethod = filterById(
      paymemtMethodOptions,
      watch2('paymentOption')
    );

    if ([paymentMethods?.NATIONAL_TDC]?.includes(PMpaymentMethod?.name)) {
      console.log('as:');
      if (
        !watch2(`identification${payment?.paymentNumber}`) ||
        !watch2(`identificationType${payment?.paymentNumber}`) ||
        !watch2(`cvc${payment?.paymentNumber}`) ||
        !watch2(`cardDate${payment?.paymentNumber}`) ||
        !watch2(`card${payment?.paymentNumber}`)
      ) {
        notify(
          'Por favor ingrese todos los datos solicitados para continuar',
          'error'
        );
        return null;
      }
    }
    const params = ['phone', 'bank', 'date'];
    // IF the payment is made in CASH then set the ref message
    for (let i = 0; i < payment?.methods?.length; i++) {
      // Valida los Pago movil de bancamigasolamente
      if (
        [paymentMethods.PAGO_MÓVIL_BANCAMIGA].includes(
          payment?.methods[i]?.name
        )
      ) {
        const isPMValid = await validatePagoMovil(
          params,
          payment?.paymentNumber,
          payment?.methods[i]
        );
        if (!isPMValid) {
          return null;
        }
      }
      if (
        [paymentMethods.CASH_BS, paymentMethods.CASH_USD].includes(
          payment?.methods[i]?.name
        )
      ) {
        setValue2(`reference${payment?.paymentNumber}`, 'PAGO EFECTIVO');
      }
    }

    if (
      [paymentMethods?.PAGO_MÓVIL_BANCAMIGA]?.includes(
        payment?.methods[0]?.name
      )
    ) {
      const isPMValid = validatePagoMovil(params, payment?.paymentNumber);
      if (!isPMValid) {
        return null;
      }
    }

    // Validate If first Image is Up
    if (
      ![
        paymentMethods.PUNTO_DE_VENTA,
        paymentMethods.TDC,
        paymentMethods.NATIONAL_TDC,
      ]?.includes(payment?.methods[0]?.name) &&
      ((!watch2(`reference${payment?.paymentNumber}`) &&
        !isPaymentMethodZelleOrPaypal(
          watch2(`method${payment?.paymentNumber}`),
          paymemtMethodOptions
        )) ||
        !fileUploaded[payment?.paymentNumber])
    ) {
      notify('Subir imagen y datos de referencia de pago', 'info');
      return null;
    }

    // IF method is cash dont ask for reference and pay

    setSelectedMethod('');

    calculateCashBack(payment?.paymentNumber);

    setPayment(prevState => {
      return {
        ...prevState,
        isOpen: false,
        methods: [],
        paymentNumber: '',
        reference: '',
        selectedMembership: selectedMembership ? selectedMembership : '',
      };
    });
  };

  const calculateCashBack = paymentNumber => {
    const paymentMethodsQuantity = NaNtoNumber(watch('paymentMethodsQuantity'));
    if (paymentNumber !== paymentMethodsQuantity - 1) {
      return null;
    }

    let totalPaid = 0;
    let totalCashPaid = 0;
    let totalAmount = 0;

    for (let i = 0; i < paymentMethodsQuantity; i++) {
      totalAmount =
        totalAmount + NaNtoNumber(parseFloat(watch(`finalAmount${i}`)));
      totalCashPaid =
        totalCashPaid + NaNtoNumber(parseFloat(watch(`paid${i}`)));
      totalPaid =
        totalPaid +
        (NaNtoNumber(parseFloat(watch(`paid${i}`))) > 0
          ? NaNtoNumber(parseFloat(watch(`paid${i}`)))
          : NaNtoNumber(parseFloat(watch(`finalAmount${i}`))));
    }

    let amountReturned = totalPaid - totalAmount;

    if (amountReturned > 0) {
      setValue('paid', totalCashPaid);
      setValue('paidBsS', (parseFloat(watch('paid')) * dollarRate)?.toFixed(2));
      setValue('amountReturned', amountReturned);
      setValue('amountReturnedBsS', (amountReturned * dollarRate).toFixed(2));
      setValue('cashbackMethodsQuantity', 1);
      setValue(`returnedAmount0`, Math.abs(amountReturned));
      setValue(
        `returnedAmountBsS0`,
        (parseFloat(watch('amountReturned')) * dollarRate)?.toFixed(2)
      );
    }
  };

  const cancelPayment = paymentNumber => {
    setValue2(`method${paymentNumber}`, '');
    setValue2(`reference${paymentNumber}`, '');
    setValue2(`amount${paymentNumber}IGTF`, 0);

    removeImage(paymentNumber);

    setPayment(prevState => {
      return {
        ...prevState,
        isOpen: false,
        methods: [],
        paymentNumber: paymentNumber,
        reference: '',
      };
    });
  };

  const cancelRenovation = () => {
    localStorage.removeItem('membership');
    history.push('/');
  };

  const validateCode = (
    { code, codeType, planId, rcvId } = {},
    { silent = false } = {}
  ) => {
    const selectedCode = code || watch('codigo');
    const selectedCodeType = codeType || watch('codeType');
    const selectedPlanId = planId || watch('code');
    const selectedRcvId = rcvId || watch('rcv');

    let discountType = '';

    if (selectedCodeType === codeTypeEnum?.DISCOUNT) {
      discountType = 'discountCodes';
    }
    if (selectedCodeType === codeTypeEnum?.GIFTCARD) {
      discountType = 'giftcards';
    }

    let params = {
      code: selectedCode,
      type:
        selectedCodeType === codeTypeEnum?.DISCOUNT
          ? validateCodeEnum?.RENEWAL
          : '',
    };

    return giftCardService
      .validateDiscount(discountType, filterParams(params))
      .then(response => {
        if ([200, 201].includes(response.status)) {
          const [option] = planOptions?.filter(p => p?._id === selectedPlanId);
          if (selectedCodeType === codeTypeEnum?.DISCOUNT) {
            const [appliesToMemberships] =
              response?.data?.appliesToMemberships?.filter(
                m => m?._id === option?._id
              );
            if (!appliesToMemberships) {
              if (!silent) {
                notify(
                  'El código ingresado no es valido para el tipo de plan a renovar',
                  'info'
                );
              }
              return null;
            } else {
              setDiscountId(response?.data?._id);
              calculateRenewalPrice(response?.data?._id, {
                planId: selectedPlanId,
                rcvId: selectedRcvId,
                codeType: selectedCodeType,
              });
              return true;
            }
          } else {
            setDiscountId(response?.data?._id);
            calculateRenewalPrice(response?.data?._id, {
              planId: selectedPlanId,
              rcvId: selectedRcvId,
              codeType: selectedCodeType,
            });
            return true;
          }
        } else {
          if ([404].includes(response.status)) {
            if (!silent) {
              notify(`Codigo no encontrado o expirado`, 'info');
            }
            return null;
          }

          if (!silent) {
            notify(`${response.message}`, 'error');
          }
        }

        return false;
      })
      .catch(() => {
        if (!silent) {
          notify(`No se pudo validar el código`, 'error');
        }
        return false;
      });
  };

  const tryApplyActiveLandingDiscount = async ({ planId, rcvId } = {}) => {
    const selectedPlanId = planId || watch('code');
    const selectedRcvId = rcvId || watch('rcv');
    const membershipData = getStoredMembership();

    if (!isEligibleForAutoDiscount(membershipData)) {
      setDontShowDiscount(true);
      return false;
    } else {
      setDontShowDiscount(false);
    }

    if (!selectedPlanId || !selectedRcvId) {
      return false;
    }

    try {
      const response = await discountService.getActiveDiscount({
        landing: 'selfRenewal',
      });
      const activeCode = response?.data?.discountCode?.code;

      if (!activeCode) {
        return false;
      }

      setValue('codeType', codeTypeEnum.DISCOUNT);
      setValue('codigo', activeCode);

      const wasApplied = await validateCode(
        {
          code: activeCode,
          codeType: codeTypeEnum.DISCOUNT,
          planId: selectedPlanId,
          rcvId: selectedRcvId,
        },
        { silent: true }
      );

      return !!wasApplied;
    } catch (error) {
      console.log('active landing discount lookup failed', error);
      return false;
    }
  };

  const handleCodeChange = () => {
    setValue('codigo', '');
    setDiscountId('');
    calculateRenewalPrice('');
  };

  const handleReferenceChange = e => {
    const { value } = e?.target;
    setPayment(prevState => {
      return {
        ...prevState,
        reference: value,
      };
    });

    setValue2(`reference${payment?.paymentNumber}`, value);
  };

  const onSubmit = handleSubmit2(async data => {
    let dataToPost = { ...data };

    if (parseFloat(data?.finalPrice) === 0) {
      showConfimedPayment();
      return null;
    }

    delete dataToPost?.finalPrice;
    delete dataToPost?.finalPriceInBsS;
    delete dataToPost?.paymentOption;
    delete dataToPost?.selectedMembership;

    dataToPost.membership = selectedMembership?._id;
    dataToPost = loadPaymentForms(dataToPost);

    if (!dataToPost) {
      return null;
    }

    let fileToPost = appendFile(dataToPost);

    if (!isLoading && fileToPost) {
      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      const dataLayer = {
        event: 'add_payment_info',
        ecommerce: {
          currency: 'USD',
          value: parseFloat(dataToPost?.billAmount) || 0,
          coupon: watch('codigo') || '',
          payment_type: dataToPost?.paymentType,
          payment_methods_quantity: `${dataToPost.allPayments.length} Método de pago`,
          payment_method:
            dataToPost?.allPayments[0]?.methodName +
            (dataToPost?.allPayments[1]?.methodName
              ? `,${dataToPost?.allPayments[1]?.methodName}`
              : ''),
          items: [
            {
              item_id: membership?.vehicle?.membership?._id,
              item_name: selectedMembership?.code,
              plan_category: `Planes de ${capitalize(membership?.vehicle?.class?.class)}`,
              discount: watch('discount') || 0,
              coupon: watch('codigo') || '',
              payment_method_1: dataToPost?.allPayments[0]?.methodName || '',
              payment_method_1_amount:
                dataToPost?.allPayments[0]?.amount +
                  dataToPost?.allPayments[0]?.amountIGTF || 0,
              payment_method_2: dataToPost?.allPayments[1]?.methodName || '',
              payment_method_2_amount:
                dataToPost?.allPayments[1]?.amount +
                  dataToPost?.allPayments[1]?.amountIGTF || 0,
              item_category: selectedMembership?.code,
              price: parseFloat(dataToPost?.billAmount) || 0,
              funnel_type: 'renovación',
              quantity: 1,
            },
          ],
        },
        // If logged In
      };
      const dataLayer2 = {
        event: 'purchase',
        ecommerce: {
          transaction_id: membership?.vehicle?.membership?._id || '',
          currency: 'USD',
          value: parseFloat(watch2('finalPrice')) || 0,
          coupon: watch('codigo') || '',
          tax:
            checkNumValue(dataToPost?.allPayments[0]?.amountIGTF) +
              checkNumValue(dataToPost?.allPayments[1]?.amountIGTF) || 0,
          items: [
            {
              item_id: membership?.vehicle?.membership?._id,
              item_name: selectedMembership?.code,
              discount: watch('discount') || 0,
              coupon: watch('codigo') || '',
              item_category: selectedMembership?.code,
              plan_category: `Planes de ${capitalize(membership?.vehicle?.class?.class)}`,
              payment_method_1: dataToPost?.allPayments[0]?.methodName || '',
              payment_method_1_amount:
                dataToPost?.allPayments[0]?.amount +
                  dataToPost?.allPayments[0]?.amountIGTF || 0,
              payment_method_2: dataToPost?.allPayments[1]?.methodName || '',
              payment_method_2_amount:
                dataToPost?.allPayments[1]?.amount +
                  dataToPost?.allPayments[1]?.amountIGTF || 0,
              price: parseFloat(dataToPost?.billAmount) || 0,
              funnel_type: 'renovación',
              quantity: 1,
            },
          ],
        },
        // If logged In
      };

      const fb1 = {
        content_ids: [membership?.vehicle?.membership?._id],
        content_name: selectedMembership?.code,
        content_category: selectedMembership?.code,
        plan_category: `Planes de ${capitalize(membership?.vehicle?.class?.class)}`,
        content_type: 'product',
        currency: 'USD',
        funnel_type: 'renovación',
        value: watch2('finalPrice') || 0,
      };

      const fb2 = {
        content_ids: [membership?.vehicle?.membership?._id],
        content_name: selectedMembership?.code,
        content_category: selectedMembership?.code,
        plan_category: `Planes de ${capitalize(membership?.vehicle?.class?.class)}`,
        content_type: 'product',
        currency: 'USD',
        funnel_type: 'renovación',
        value: watch2('finalPrice') || 0,
        num_items: 1,
      };

      if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
        window.fbq('track', 'AddPaymentInfo', fb1);
        window.fbq('track', 'Purchase', fb2);
      }

      window.dataLayer.push(dataLayer);
      window.dataLayer.push(dataLayer2);

      setIsloading(true);
      paymentsService
        .createMembershipPayment(fileToPost)
        .then(response => {
          if ([200, 201].includes(response.status)) {
            setIsloading(false);
            showConfimedPayment();
          } else {
            setIsloading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(error => {
          setIsloading(false);
          notify(`ERROR al realizar el pago`, 'error');
        });
    }
  });

  const appendFile = data => {
    const formData = new FormData();
    formData.append('membership', data?.membership);
    formData.append('paymentType', data?.paymentType);

    for (var i = 0; i < data?.payments?.length; i++) {
      formData.append(`payments[${i}][method]`, data?.payments[i]?.method);
      formData.append(`payments[${i}][amount]`, data?.payments[i]?.amount);
      formData.append(
        `payments[${i}][amountBsS]`,
        data?.payments[i]?.amountBsS
      );
      formData.append(
        `payments[${i}][igtfAmount]`,
        data?.payments[i]?.igtfAmount
      );
      formData.append(
        `payments[${i}][igtf]`,
        data?.payments[i]?.igtfAmount ? true : false
      );
      if (data?.payments[i]?.bank) {
        formData.append(`payments[${i}][phone]`, data?.payments[i]?.phone);
        formData.append(`payments[${i}][bank]`, data?.payments[i]?.bank);
      }
      // Send the flag if the payment has image or not
      // Send the flag if the payment has image or not
      formData.append(
        `payments[${i}][hasEvidence]`,
        fileUploaded[i]?.name ? true : false
      );
      if (fileUploaded[i]?.name) {
        formData.append(`paymentEvidence`, fileUploaded[i]);
      }

      if (
        data?.payments[i]?.bank &&
        data?.payments[i]?.method ===
        paymemtMethodOptions?.filter(
          p => p?.name === paymentMethods?.CASHEA
        )[0]?._id
      ) {
        formData.append(`payments[${i}][date]`, data?.payments[i]?.date);
      } else {
        formData.append(`payments[${i}][date]`, selectedMembership?.createdAt);
      }
      if (
        data?.payments[i]?.reference &&
        data?.payments[i]?.reference.trim() !== ''
      ) {
        formData.append(
          `payments[${i}][reference]`,
          data?.payments[i]?.reference
        );
      }

      if (data?.paymentType === paymentTypeOption?.CASHEA) {
        formData.append(`payments[${i}][referenceCashea]`, data?.casheaOrderId);
      }

      if (
        isPaymentMethodZelleOrPaypal(
          data?.payments[i]?.method,
          paymemtMethodOptions
        )
      ) {
        // for zelle payments
        formData.append(`payments[${i}][accHolder]`, data?.payments[i]?.owner);
      }

      if (
        [paymentMethods?.NATIONAL_TDC].includes(
          filterById(paymemtMethodOptions, data?.payments[i]?.method)?.name
        )
      ) {
        formData.append(
          `payments[${i}][identification]`,
          data?.payments[i]?.identification
        );
        formData.append(`payments[${i}][cardCvc]`, data?.payments[i]?.cardCvc);
        formData.append(
          `payments[${i}][creditCard]`,
          data?.payments[i]?.creditCard
        );
        formData.append(
          `payments[${i}][cardMonth]`,
          data?.payments[i]?.cardMonth
        );
        formData.append(
          `payments[${i}][cardYear]`,
          data?.payments[i]?.cardYear
        );
      }

      if (data?.paymentType === paymentTypeOption?.CASHEA) {
        formData.append(`numCasheaDues`, parseFloat(data?.numCasheaDues) + 1);
        formData.append(`casheaOrderId`, data?.casheaOrderId);
        formData.append(`casheaDownPayment`, data?.casheaDownPayment);
        formData.append(`casheaParentOrderId`, data?.casheaParentOrderId);
      }
    }

    return formData;
  };

  const storeData = params => {
    for (let i = 0; i < params?.allPayments?.length; i++) {
      params.allPayments[i].methodName = paymemtMethodOptions?.filter(
        p => p?._id === params?.allPayments[i]?.method
      )[0]?.name;
      params.allPayments[i].currency = paymemtMethodOptions?.filter(
        p => p?._id === params?.allPayments[i]?.method
      )[0]?.currency;
    }

    sessionStorage.setItem('payment', JSON.stringify(params));
  };

  const showConfimedPayment = () => {
    history.push('/confirmed-payment');
  };

  // Validate if all payments were made via TDC
  const paymentsWithTDC = stripeId => {
    // Si esta loggeado no pasas por el proceso regular de pago de TCD
    // if (authService?.getUser()) {
    //   return false;
    // }

    let paymenTDCounter = 0;
    let paymentMethodsQuantity = parseInt(watch('paymentMethodsQuantity'));
    for (let i = 0; i < paymentMethodsQuantity; i++) {
      if (stripeId?._id === watch(`method${i + 1}`)) {
        paymenTDCounter = paymenTDCounter + 1;
      }
    }
    if (paymenTDCounter === paymentMethodsQuantity) {
      // Save data to local storage and jump to next step
      // updateMembershipStatus(membership?._id);
      // setcurentStep(curentStep + 1);
      // return true;
      return false;
    } else {
      return false;
    }
  };

  let loadPaymentForms = params => {
    let [stripeId] = paymemtMethodOptions?.filter(
      p => p?.name === paymentMethods?.STRIPE
    );

    let payments = [];
    let allPayments = [];
    // lOOP through every payment method
    for (let i = 0; i < parseInt(watch2('paymentMethodsQuantity')); i++) {
      let data = {
        method: params[`method` + i.toString()],
        reference: params[`reference` + i.toString()],
        referenceCashea: watch('referenceCashea'),
        amountIGTF: parseFloat(params[`IGTF` + i.toString()]),
        amount: parseFloat(params[`amount` + i.toString()]),
        amountBsS: parseFloat(params[`finalAmountBsS` + i.toString()]),
        bank: params[`bank` + i.toString()],
        phone: params[`phone` + i.toString()],
        date: params[`date` + i.toString()],
      };

      allPayments.push(filterParams(data));

      let data2 = {};
      data2.method = params[`method` + i.toString()];
      data2.amountBsS = params[`finalAmountBsS` + i.toString()];
      data2.reference = params[`reference` + i.toString()];
      data2.referenceCashea = watch('referenceCashea');
      data2.owner = params[`owner` + i.toString()];
      data2.igtfAmount = parseFloat(params[`IGTF` + i.toString()]);
      data2.bank = params[`bank` + i.toString()];
      data2.phone = params[`phone` + i.toString()];
      data2.date = params[`date` + i.toString()];

      // Amount with or without IGTF
      data2.amount = parseFloat(params[`amount` + i.toString()]);

      if (
        [paymentMethods?.NATIONAL_TDC].includes(
          filterById(paymemtMethodOptions, params[`method` + i.toString()])
            ?.name
        )
      ) {
        data2.identification = params[`identification` + i.toString()];
        data2.cardCvc = params[`cvc` + i.toString()];
        data2.creditCard = params[`card` + i.toString()];
        const date = params[`cardDate` + i.toString()].split('/');
        data2.cardMonth = date[0];
        data2.cardYear = date[1];
      }

      payments?.push({
        ...data2,
      });
    }

    // "REmove unwanted params from JSON"
    let words = [
      'method',
      'reference',
      'amount',
      'amountIGTF',
      'amountBsS',
      'paymentMethod',
      'bank',
      'phone',
      'date',
    ];
    for (const key in params) {
      for (var i = 0, ln = words.length; i < ln; i++) {
        if (key.indexOf(words[i]) !== -1) {
          delete params[key];
        }
      }
    }

    params.payments = payments;
    params.allPayments = allPayments;
    storeData(params);
    const tdc = paymentsWithTDC(stripeId);

    if (tdc) {
      return null;
    } else {
      return params;
    }
  };

  const specialPayment = () => {
    const formData = new FormData();

    formData.append('paymentType', watch2('paymentType'));
    formData.append('membership', selectedMembership?._id);

    if (!isLoading) {
      setIsloading(true);
      paymentsService
        .createMembershipPayment(formData)
        .then(response => {
          if ([200, 201].includes(response.status)) {
          } else {
            setIsloading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => {
          setIsloading(false);
        });
    }
  };

  const validateButtonName = () => {
    let label = 'Siguiente';
    let action = onSubmit;

    if (
      parseFloat(watch2('finalPrice')) === 0 &&
      watch2('paymentType') === paymentTypeOption?.DE_CONTADO
    ) {
      action = showConfimedPayment;
      return <ActionButton label={label} action={action} />;
    }

    if (
      [paymentTypeOption?.COURTESY, paymentTypeOption?.PENDING].includes(
        watch2('paymentType')
      )
    ) {
      label = `Registrar pago ${watch2('paymentType')}`;
      action = specialPayment;
    }
    const lastIndex = parseFloat(watch2('paymentMethodsQuantity')) - 1;
    if (
      ![paymentMethods?.NATIONAL_TDC].includes(
        filterById(paymemtMethodOptions, watch2(`method${lastIndex}`))?.name
      ) &&
      !watch2(`reference${lastIndex}`) &&
      !fileUploaded[lastIndex] &&
      parseFloat(watch2('finalPrice')) !== 0
    ) {
      return null;
    }

    return <ActionButton label={label} action={action} />;
  };

  const preloadVehicleData = () => {
    let membership = localStorage.getItem('membership');
    membership = JSON.parse(membership);
    setMembership(membership);

    if (!watch('profession')) {
      setValue('profession', membership?.vehicle?.customer?.profession);
      setValue(
        'economicActivity',
        membership?.vehicle?.customer?.economicActivity
      );
      setValue(
        'otherEconomicActivity',
        membership?.vehicle?.customer?.otherEconomicActivity
      );
      setValue('engineSerial', membership?.vehicle?.engineSerial);
    }
  };

  const calculateRenewalPrice = (discountId, options = {}) => {
    const selectedPlanId = options?.planId || watch('code');
    const selectedRcvId = options?.rcvId || watch('rcv');
    const selectedCodeType = options?.codeType || watch('codeType');

    const params = {
      rcv: selectedRcvId === 'ninguno' ? '' : selectedRcvId,
      code: selectedPlanId,
      giftcard: selectedCodeType === codeTypeEnum?.GIFTCARD ? discountId : '',
      discountCode:
        selectedCodeType === codeTypeEnum?.DISCOUNT ? discountId : '',
    };

    preloadVehicleData();

    const selectedOption = getPlanOption(selectedPlanId);
    const renewalKm = resolveRenewalKm(selectedPlanId);

    if (renewalKm) {
      setValue('km', renewalKm);
      params.km = renewalKm;
    } else if (selectedOption) {
      setValue('km', '');
    }

    params.useExtendedTow =
      selectedOption && planAllowsUnlimitedTow(selectedOption?.name)
        ? Boolean(watch('hasExtendedTow'))
        : false;

    if (selectedOption && !planAllowsUnlimitedTow(selectedOption?.name)) {
      setValue('hasExtendedTow', false);
    }

    if (!isLoading) {
      setIsloading(true);
      membershipService
        .calculateRenewalPrice(filterParams(params), membershipId)
        .then(response => {
          if (response.message === 'Success') {
            if (response.status === 200) {
              setValue(
                'discount',
                response?.data?.discountByGiftcard ||
                response?.data?.discountByCode ||
                0
              );
              setPriceInfo(response?.data);
              setIsloading(false);
            }
            return null;
          }
          if (
            response.status === 400 &&
            [
              'discountCode contains an invalid value',
              'giftcard contains an invalid value',
            ]?.includes(response?.message)
          ) {
            notify(`Codigo Invalido`, 'info');
            setIsloading(false);
          } else {
            notify(`${response.message}`, 'error');
            setIsloading(false);
          }
        })
        .catch(() => { });
    }
  };

  const getRCVs = membershipType => {
    const requestSeq = ++rcvRequestSeqRef.current;
    setRcvLoadedPlanId('');

    syncPlanExtras(membershipType || watch('code'));

    if (membershipType) {
      productService
        .getRCVs(membershipType)
        .then(response => {
          if (requestSeq !== rcvRequestSeqRef.current) {
            return null;
          }

          if (response.status === 200) {
            let data = [{ _id: 'ninguno', name: 'N/A' }, ...response?.data];
            let [basico] = data?.filter(p => p?.name === rcvEnum?.RCV_STANDARD);
            data = filterRCVOptions(data);

            setRCVOptions(data);
            if (basico) {
              setValue('rcv', basico?._id);
            }
            setRcvLoadedPlanId(membershipType);
          } else {
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch(() => { });
    }
  };

  const selfRenew = handleSubmit(async data => {
    const renewalKm = resolveRenewalKm(watch('code'));
    const selectedPlan = getPlanOption(watch('code'));
    let params = {
      code: watch('code'),
      rcvProduct: watch('rcv') === 'ninguno' ? '' : watch('rcv'),
      discountCodeId:
        watch('codeType') === codeTypeEnum?.DISCOUNT ? discountId : '',
      giftcardId:
        watch('codeType') === codeTypeEnum?.GIFTCARD ? discountId : '',
      km: renewalKm,
      engineSerial: watch('engineSerial') ? watch('engineSerial') : '',
      profession: watch('profession') ? watch('profession') : '',
      economicActivity: watch('economicActivity')
        ? watch('economicActivity')
        : '',
      otherEconomicActivity: watch('otherEconomicActivity')
        ? watch('otherEconomicActivity')
        : '',
      vehicleUsage: watch('vehicleUsage') ? watch('vehicleUsage') : '',
      seats: watch('seats') ? watch('seats') : '',
      useExtendedTow: planAllowsUnlimitedTow(selectedPlan?.name)
        ? Boolean(watch('hasExtendedTow'))
        : false,
    };

    if (!isLoading) {
      setIsloading(true);
      membershipService
        .selfRenew(filterParams(params), membershipId)
        .then(response => {
          if ([200, 201]?.includes(response.status)) {
            const dataLayer = {
              event: 'funnel_renovacion_step_plan_info',
              plan_category: `Planes de ${capitalize(membership?.vehicle?.class?.class)}`,
              plan_name:
                capitalize(filterById(planOptions, watch('code'))?.name) ||
                'N/A',
              rcv: filterById(rcvOptions, watch('rcv'))?.name || 'N/A',
              km_crane_service: renewalKm ? `${renewalKm} km` : '',
              coupon_type: watch('codeType') || '',
              coupon: watch('codigo') || '',
              vehicle_use: watch('vehicleUsage'),
            };
            // If logged In
            window.dataLayer.push(dataLayer);
            setIsloading(false);
            const planName = filterById(planOptions, watch('code'))?.name;
            setSelectedMembership({
              ...response?.data,
              code: planName || getMembershipCode(response?.data),
            });
            setValue2(
              'selectedMembership',
              planName || getMembershipCode(response?.data)
            );
            setValue2('code', watch('code'));
            setValue2('rcv', watch('rcv'));
            setValue2('finalPrice', priceInfo?.finalPrice?.toFixed(2));
            setValue2(
              'finalPriceInBsS',
              priceInfo?.finalPriceInBsS?.toFixed(2)
            );
            setValue2('paymentType', paymentTypeOption?.DE_CONTADO);
            setValue2('paymentMethodsQuantity', 1);
            setValue2('billAmount', watch2('finalPrice'));
            setValue2('amount0', watch2('finalPrice'));
            setValue2('amountBsS0', watch2('finalPriceInBsS'));
          } else {
            setIsloading(false);
            notify(`${response.message}`, 'error');
          }
        })
        .catch(() => { });
    }
  });

  const preloadPage = () => {
    let membership = localStorage.getItem('membership');
    if (membership) {
      membership = JSON.parse(membership);
      getAvailableMemberships(membership);
    } else {
      history.push('/');
    }
  };

  const setPaymentType = () => {
    let paymentType = watch2('paymentType');
    if ([paymentTypeOption?.DE_CONTADO].includes(paymentType)) {
      setValue2('amount1', priceInfo?.finalPrice?.toFixed(2));
      setValue2('amountBsS1', priceInfo?.finalPriceInBsS?.toFixed(2));
      setValue2('paymentMethodsQuantity', '1');
    }

    if (paymentType === paymentTypeOption?.FINANCIADO) {
      setValue2('paymentMethodsQuantity', '1');
    }

    if (paymentType === paymentTypeOption?.CASHEA) {
      setValue2('paymentMethodsQuantity', 1);
    }
  };

  useEffect(() => {
    getEconomicActivities();
    getDollarRate();
    preloadPage();
    getPaymentMethods();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const isPlanReady = planOptions?.some(p => p?._id === selectedCode);
    const isRcvReady =
      rcvLoadedPlanId === selectedCode &&
      rcvOptions?.some(r => r?._id === selectedRcv);

    if (!selectedCode || !selectedRcv || !isPlanReady || !isRcvReady) {
      return;
    }

    const requestKey = `${selectedCode}-${selectedRcv}`;
    const codeAlreadyApplied =
      selectedCodeType === codeTypeEnum.DISCOUNT &&
      !!selectedCoupon &&
      !!discountId;

    if (
      codeAlreadyApplied ||
      promoAutoAppliedRef.current === requestKey ||
      autoDiscountRequestRef.current === requestKey
    ) {
      return;
    }

    autoDiscountRequestRef.current = requestKey;
    promoAutoAppliedRef.current = requestKey;

    tryApplyActiveLandingDiscount({
      planId: selectedCode,
      rcvId: selectedRcv,
    })
      .then(wasApplied => {
        if (!wasApplied) {
          calculateRenewalPrice('', {
            planId: selectedCode,
            rcvId: selectedRcv,
          });
        }
      })
      .finally(() => {
        if (autoDiscountRequestRef.current === requestKey) {
          autoDiscountRequestRef.current = '';
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedCode,
    selectedRcv,
    selectedCodeType,
    selectedCoupon,
    discountId,
    planOptions,
    rcvOptions,
    rcvLoadedPlanId,
  ]);

  const validateRCVType = () => isGoldPlanName(getPlanOption(watch('code'))?.name);

  const validateUnlimitedTow = () =>
    planAllowsUnlimitedTow(getPlanOption(watch('code'))?.name);

  return (
    <>
      <LoadSpinner label={''} show={isLoading} />

      <div className="container view-content">
        <form>
          <div className="row">
            <div className="col-12 login-page-container">
              <div className="login-form">
                <div className="login-logo-container">
                  <LogoButton link={'/'} src={logo} />
                  <h5 style={{ marginTop: '24px' }}>Renovación de Plan </h5>
                  <h6>Información de la Renovación</h6>
                </div>
                {!selectedMembership ? (
                  <>
                    <div className="row">
                      <Input
                        bootstrap={'col-6 col-md-6 '}
                        label={'Plan a Renovar'}
                        type={'select'}
                        name={'code'}
                        register={register}
                        placeholder={''}
                        options={planOptions}
                        errors={errors?.code?.message}
                        onChange={() => getRCVs(watch('code'))}
                      />
                      <Input
                        bootstrap={'col-6 col-md-6 '}
                        label={'RCV'}
                        type={'select'}
                        name={'rcv'}
                        register={register}
                        placeholder={''}
                        options={rcvOptions}
                        errors={errors?.rcv?.message}
                        disabled={!watch('code')}
                        onChange={() => calculateRenewalPrice('')}
                      />
                      {validateRCVType() && (
                        <>
                          <Input
                            bootstrap={'col-12 col-md-6'}
                            label={'Km de Servicio de Grúa'}
                            type={'select'}
                            name={'km'}
                            options={getKmServiceOptions(getContractedCraneKm())}
                            placeholder={''}
                            register={register}
                            errors={errors?.km?.message}
                            onChange={() => calculateRenewalPrice(discountId)}
                          />
                          <div className="col-12 col-md-6"></div>
                        </>
                      )}
                      {validateUnlimitedTow() && (
                        <>
                          <Input
                            bootstrap={'col-12 col-md-6 mt-0'}
                            subLabel={getUnlimitedTowLabel()}
                            type={'checkbox'}
                            name={'hasExtendedTow'}
                            register={register}
                            placeholder={''}
                            errors={errors?.hasExtendedTow?.message}
                            onChange={() => calculateRenewalPrice(discountId)}
                          />
                          <div className="col-12 col-md-6"></div>
                        </>
                      )}

                      <Input
                        bootstrap={'col-6 col-md-6 '}
                        label={'Tipo de Código'}
                        type={'select'}
                        name={'codeType'}
                        register={register}
                        placeholder={''}
                        options={
                          dontShowDiscount
                            ? codeTypeOptions?.filter(
                              o => o?._id !== codeTypeEnum?.DISCOUNT
                            )
                            : codeTypeOptions
                        }
                        errors={errors?.codeType?.message}
                        onChange={() => handleCodeChange()}
                      />
                      <Input
                        bootstrap={'col-6'}
                        label={'Código'}
                        type={'text'}
                        name={'codigo'}
                        register={register}
                        placeholder={''}
                        errors={errors?.codigo?.message}
                        disabled={!watch('codeType')}
                      // onChange={() => handleDiscountCode()}
                      />

                      {watch('codeType') &&
                        watch('codigo') &&
                        watch('codigo')?.length >= 6 && (
                          <div className="col-12">
                            <div className="buttons-center-container">
                              <ActionButton
                                label={'Canjear Código'}
                                action={() => handleDiscountCode()}
                              />
                            </div>
                          </div>
                        )}

                      {watch('rcv') !== 'ninguno' && (
                        <>
                          <h5
                            style={{
                              textAlign: 'center',
                              marginTop: '24px',
                              marginBottom: '12px',
                            }}
                          >
                            Información para Solicitud RCV
                          </h5>
                          <Input
                            bootstrap={'col-12 col-md-6'}
                            label={'Serial Motor *'}
                            type={'text'}
                            name={'engineSerial'}
                            register={register}
                            placeholder={''}
                            errors={errors?.engineSerial?.message}
                          />
                          <Input
                            bootstrap={'col-12 col-md-6'}
                            label={'Puestos del Vehículo *'}
                            type={'number'}
                            name={'seats'}
                            register={register}
                            placeholder={''}
                            errors={errors?.seats?.message}
                          />
                          <Input
                            bootstrap={'col-12 col-md-6'}
                            label={'Uso del Vehículo *'}
                            type={'select'}
                            options={vehicleUsageOptions}
                            name={'vehicleUsage'}
                            register={register}
                            placeholder={''}
                            errors={errors?.vehicleUsage?.message}
                          />
                          <Input
                            bootstrap={'col-12 col-md-6'}
                            label={'Profesión/Ocupación *'}
                            type={'text'}
                            name={'profession'}
                            register={register}
                            placeholder={''}
                            errors={errors?.profession?.message}
                          />
                          <Input
                            bootstrap={'col-12 col-md-6'}
                            label={'Actividad Económica *'}
                            type={'select'}
                            options={economicActivitiesOptions}
                            name={'economicActivity'}
                            register={register}
                            placeholder={''}
                            errors={errors?.economicActivity?.message}
                          />
                          {validateIfOther(
                            watch,
                            economicActivitiesOptions
                          ) && (
                              <Input
                                bootstrap={'col-12 col-md-6'}
                                label={'Otra Actividad Económica *'}
                                type={'text'}
                                name={'otherEconomicActivity'}
                                register={register}
                                placeholder={''}
                                errors={errors?.otherEconomicActivity?.message}
                              />
                            )}
                        </>
                      )}
                    </div>
                    <div className="row">
                      <div className="col-3"></div>
                      <div className="col-12 col-lg-6">
                        <div className="autorenovation-text-container">
                          <p style={{ textAlign: 'center' }}>
                            {' '}
                            {priceInfo?.initialValue > 0
                              ? `Subtotal: ${priceInfo?.initialValue} $`
                              : ''}
                          </p>
                          <p>
                            {' '}
                            {priceInfo?.rcvSurcharge > 0
                              ? `Recargo por RCV: +${priceInfo?.rcvSurcharge?.toFixed(
                                2
                              )} $`
                              : ''}
                          </p>
                          <p>
                            {' '}
                            {priceInfo?.renewalSurcharge > 0
                              ? `Recargo por Siniestralidad: +${priceInfo?.renewalSurcharge?.toFixed(
                                2
                              )} $`
                              : ''}
                          </p>
                          <p>
                            {' '}
                            {priceInfo?.kmSurcharge > 0
                              ? `Recargo por Km extra: ${priceInfo?.kmSurcharge?.toFixed(
                                2
                              )} $`
                              : ''}
                          </p>
                          <p>
                            {' '}
                            {priceInfo?.discountByCode > 0
                              ? `Cupones aplicados: -${priceInfo?.discountByCode?.toFixed(
                                2
                              )} $`
                              : ''}
                          </p>
                          <p>
                            {' '}
                            {priceInfo?.discountByRenewal > 0
                              ? `Descuento por renovación anticipada: -${priceInfo?.discountByRenewal?.toFixed(
                                2
                              )} $`
                              : ''}
                          </p>
                          <p>
                            {' '}
                            {priceInfo?.discountByGiftcard > 0
                              ? `Giftcard aplicadas: -${priceInfo?.discountByGiftcard?.toFixed(
                                2
                              )} $`
                              : ''}
                          </p>
                          <h6>
                            {priceInfo?.finalPrice > 0
                              ? `Monto a pagar: ${priceInfo?.finalPrice?.toFixed(
                                2
                              )} $`
                              : ''}
                          </h6>
                        </div>
                      </div>
                      <div className="col-3"></div>
                    </div>
                    <div
                      className="buttons-center-container"
                      style={{ margin: '0px 0px 48px 0px' }}
                    >
                      <AltButton
                        label={'Cancelar Renovacion'}
                        action={cancelRenovation}
                      />
                      <ActionButton label={'Continuar'} action={selfRenew} />
                    </div>
                  </>
                ) : (
                  <RenewPayment
                    cancelRenovation={cancelRenovation}
                    register={register2}
                    setValue={setValue2}
                    control={control2}
                    errors={errors2}
                    watch={watch2}
                    options={{
                      planOptions: planOptions,
                      rcvOptions: rcvOptions,
                    }}
                    setPaymentType={setPaymentType}
                    stripeModal={stripeModal}
                    handleStipeModal={handleStipeModal}
                    // clientSecret={clientSecret}
                    selectedMembership={selectedMembership}
                    successfulStripe={successfulStripe}
                    removeImage={removeImage}
                    dollarRate={dollarRate}
                    payment={payment}
                    setPayment={setPayment}
                    selectedMethod={selectedMethod}
                    acceptPayment={acceptPayment}
                    cancelPayment={cancelPayment}
                    fileUploaded={fileUploaded}
                    setFileUploaded={setFileUploaded}
                    // getRootProps1={getRootProps1}
                    // getInputProps1={getInputProps1}
                    // getRootProps2={getRootProps2}
                    // getInputProps2={getInputProps2}
                    // paymentImage1={paymentImage1}
                    // paymentImage2={paymentImage2}
                    handleReferenceChange={handleReferenceChange}
                    // Methods Component
                    paymemtMethodOptions={paymemtMethodOptions}
                    // setSecondPayment={setSecondPayment}
                    validateButtonName={validateButtonName}
                    isLoading={isLoading}
                    setIsloading={setIsloading}
                  />
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
